const About = () => {
  return (
    <section className='about'>
      <div className='about-l'>
        <h2>O společnosti</h2>
        <h3>Cesta k precizní výrobě</h3>
        <div className='about-info'>
          Společnost <span>CNC obrábění DUBEN, spol. s r.o.</span> byla založena
          v roce 2007 a navazuje na dlouholetou tradici firmy{' '}
          <span>Duben a synové.</span> V roce 2017 jsme přesunuli výrobu do
          nových, moderních prostor na adrese <span>Jasenná 325,</span> které
          nám umožňují dále <span>rozvíjet kvalitu</span> a kapacitu výroby. Pro
          naše obchodní partnery jsme{' '}
          <span>stabilním a spolehlivým dodavatelem.</span> V roce 2025 jsme
          implementovali <span>ERP systém TimeLine,</span> který díky integraci
          dat a pokročilému <span>APS plánování</span> zásadně zefektivnil naši
          výrobu.
        </div>
      </div>
      <div className='about-r'></div>
    </section>
  )
}

export default About
